import React from "react";

import "./Divider.style.scss";

interface DividerProps {
    theme?: "dark" | "light";
}

export const Divider = (props: DividerProps) => {
    return <div className={`component-divider divider-${props.theme || "dark"}`} />;
};
